export class CampaignsListModel {
	public campaignID: string;
	public businessName: string;
	public campaignName: string;
	public medium: string;
	public status: string;
	public numberCount: number;
	public deilveredCount: number;
	public seenCount: number;
	public responseCount: number;
	public estimatedCost: number;
	public actualCost: number;
	public startDate: string;
	public endDate: string;
	public id: string;

	public convert(dto: any): CampaignsListModel {
		if (dto.campaignID) {
			this.campaignID = dto.campaignID;
		}
		if (dto.businessName) {
			this.businessName = dto.businessName;
		}
		if (dto.campaignName) {
			this.campaignName = dto.campaignName;
		}
		if (dto.medium) {
			this.medium = dto.medium;
		}
		if (dto.status) {
			this.status = dto.status;
		}
		if (dto.numberCount) {
			this.numberCount = dto.numberCount;
		}
		if (dto.deilveredCount) {
			this.deilveredCount = dto.deilveredCount;
		}
		if (dto.seenCount) {
			this.seenCount = dto.seenCount;
		}
		if (dto.responseCount) {
			this.responseCount = dto.responseCount;
		}
		if (dto.estimatedCost) {
			this.estimatedCost = dto.estimatedCost;
		}
		if (dto.actualCost) {
			this.actualCost = dto.actualCost;
		}
		if (dto.startDate) {
			this.startDate = dto.startDate;
		}
		if (dto.endDate) {
			this.endDate = dto.endDate;
		}
		if (dto.id) {
			this.id = dto.id;
		}

		return this;
	}
}
